// Log when the module is loaded
console.log('Loading select module');

import Choices from 'choices.js';
import { ancestorBySelector } from "../../helpers/element/findAncestor";
import { testing } from 'laravel-mix/src/Log';


function createSelect(selectBox, index) {
  console.log(`Creating select for element ${index}`, selectBox);

  const choice = new Choices(selectBox, {
    searchEnabled: (selectBox.dataset.choiceSearch === "true") ? true : false,
    itemSelectText: '',
    shouldSort: false,
    shouldSortItems: false,
    classNames: {
      containerOuter: 'choices choices--gforms'
    },
  });

  console.log(`Choices instance created for element ${index}`, choice);

  selectBox.choice = choice;

  selectBox.addEventListener('choice', (event) => {
    console.log(`Choice event triggered for element ${index}`, event.detail);

    const parent = ancestorBySelector(selectBox, '.gfield');
    console.log(`Found parent element`, parent);

    if (parent) {
      if (!event.detail.choice.placeholder) {
        console.log(`Activating field ${index}`);
        parent.classList.add('is-active');
      } else {
        console.log(`Deactivating field ${index}`);
        parent.classList.remove('is-active');
      }
    }

  }, false);
}

export function gravityFormSelect() {
  console.log('Initializing gravity form selects');
  
  const selectBoxes = document.querySelectorAll('.gfield_select:not(.choices__input)');
  console.log(`Found ${selectBoxes.length} select elements to enhance`);

  if (selectBoxes.length > 0) {
    selectBoxes.forEach((selectBox, i) => {
      console.log(`Processing select element ${i}`);
      createSelect(selectBox, i);
    });
  }
  
  console.log('Finished initializing all select elements');
}


// Hook into Gravity Forms refresh events
jQuery(document).on('gform_post_render', function(event, formId, currentPage) {
  console.log('Form refreshed - running gravityFormSelect again', {formId, currentPage});
      gravityFormSelect();
});